<form class="schedulingSuggestionsDialog" name="form" [formGroup]="scheduleSuggestionsFormArray" fusePerfectScrollbar>
  <span class="schedulingSuggestionsDialog__title">
    {{ 'MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.TITLE' | translate }} ({{
      scheduleSuggestionsFormArrayToSaved.value.length
    }}/{{ suggestedLimit }})
  </span>
  <span class="schedulingSuggestionsDialog__description">
    {{ 'MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.DESCRIPTION' | translate }}
  </span>
  <div
    *ngFor="let scheduleSuggestionFormGroup of scheduleSuggestionsFormArrayToSaved.controls; let i = index"
    class="schedulingSuggestionsDialog__sugestion"
  >
    <div class="schedulingSuggestionsDialog__sugestion__item">
      <span class="schedulingSuggestionsDialog__sugestion__item__title">
        {{ 'MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.SUGGESTION' | translate }} {{ i + 1 }}
      </span>

      <fc-date-input
        [control]="scheduleSuggestionFormGroup.get('date')"
        [hasGroupError]="!!scheduleSuggestionFormGroup?.errors"
        [required]="true"
        [label]="'FC_DATE_INPUT.LABEL' | translate"
        [min]="minDate"
        [fixedColor]="false"
        translateErrorPrefix="MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.ERRORS"
        [min]="scheduleSuggestionFormGroup.get('date').value"
      ></fc-date-input>

      <fc-time-input
        [control]="scheduleSuggestionFormGroup.get('time')"
        [hasGroupError]="!!scheduleSuggestionFormGroup?.errors"
        [required]="false"
        [fixedColor]="false"
        translateErrorPrefix="MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.ERRORS"
      ></fc-time-input>

      <button
        *ngIf="scheduleSuggestionsFormArrayToSaved.value.length > 1"
        [matTooltip]="'MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.DELETE_SUGGESTION' | translate"
        class="schedulingSuggestionsDialog__sugestion__item__delete"
        (click)="deleteSuggestion(i)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <span
      class="schedulingSuggestionsDialog__sugestion__error"
      *ngIf="scheduleSuggestionFormGroup.errors && scheduleSuggestionFormGroup['errorMessage']"
    >
      <small class="fc-time-input__infix-error">
        {{
          'MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.ERRORS' +
            '.' +
            scheduleSuggestionFormGroup['errorMessage'] | translate
        }}
      </small>
    </span>
  </div>

  <div
    *ngIf="scheduleSuggestionsFormArrayToSaved.value.length < suggestedLimit"
    class="schedulingSuggestionsDialog__addSugestion"
    (click)="addSuggestion()"
  >
    <span class="schedulingSuggestionsDialog__addSugestion__text">
      {{ 'MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.ADD_SUGGESTION' | translate }}
    </span>
  </div>

  <div class="schedulingSuggestionsDialog__buttons">
    <button class="schedulingSuggestionsDialog__buttons__cancel" (click)="closeDialog()">
      <span class="schedulingSuggestionsDialog__buttons__cancel__text">
        {{ 'MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.CANCEL' | translate }}
      </span>
    </button>
    <button
      class="schedulingSuggestionsDialog__buttons__save"
      [disabled]="!scheduleSuggestionsFormArrayToSaved.valid"
      [class.disabled]="!scheduleSuggestionsFormArrayToSaved.valid"
      (click)="saveSchedulingSuggestions()"
    >
      <span class="schedulingSuggestionsDialog__buttons__save__text">
        {{ 'MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.SAVE' | translate }}
      </span>
    </button>
  </div>
</form>
